// Configurable rings: switching options swaps the gallery, price, link,
// enquiry summary and the iJewel 3D view in place. Without this script the
// swatches are plain links to each variant, which the server renders.
// See docs/superpowers/specs/2026-10-10-configurable-rings-design.md
(() => {
  const IJEWEL = "https://ijewel.design/embedded";

  function start(section) {
    // The variant data sits beside the section, inside the same Shopify section wrapper.
    const data = section.parentElement.querySelector("[data-ring-variants]");
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const slug = section.dataset.ijewelSlug;
    const stage = section.querySelector("[data-ring-stage]");
    const thumbs = section.querySelector("[data-ring-thumbs]");
    const price = section.querySelector("[data-ring-price]");
    const summary = document.querySelector("[data-ring-summary]");
    const announce = section.querySelector("[data-ring-announce]");
    const fieldsets = [...section.querySelectorAll("[data-option]")];
    const selectedId = Number(new URLSearchParams(location.search).get("variant"));
    let current = variants.find((v) => v.id === selectedId) || variants[0];
    let showing = 0;
    let iframe = null;

    // The variant with this value in option i and the other choices kept, or
    // failing that the first variant that has the value at all.
    const closest = (options, i, value) => {
      const wanted = [...options];
      wanted[i] = value;
      return variants.find((v) => v.options.every((o, j) => o === wanted[j])) || variants.find((v) => v.options[i] === value);
    };
    const element = (tag, attrs = {}) => Object.assign(document.createElement(tag), attrs);

    function show(index) {
      showing = index;
      iframe = null;
      const item = current.gallery[index];
      stage.replaceChildren();
      if (!item) return;
      if (item.type === "video") {
        const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
        const video = element("video", { src: item.src, poster: item.poster, muted: true, loop: true, playsInline: true, controls: true, preload: "metadata", autoplay: !reduced });
        video.setAttribute("aria-label", item.alt);
        stage.append(video);
        if (!reduced) video.play().catch(() => {});
      } else {
        stage.append(element("img", { src: item.src, alt: item.alt, width: 1800, height: 2250 }));
      }
      markThumb(thumbs.querySelector(`[data-index="${index}"]`));
    }

    function show3d() {
      showing = "3d";
      iframe = element("iframe", { src: iframeSrc(), title: `${document.querySelector("h1")?.textContent || "Ring"} in 3D`, loading: "eager", allowFullscreen: true });
      iframe.setAttribute("allow", "camera; autoplay; clipboard-write; fullscreen; xr-spatial-tracking; web-share");
      stage.replaceChildren(iframe);
      markThumb(thumbs.querySelector("[data-3d]"));
    }
    const iframeSrc = () => `${IJEWEL}?slug=${encodeURIComponent(slug)}&isRemoveLogo=true&isTurntableAnimation=true${current.ijewel ? `#?${current.ijewel}` : ""}`;

    function markThumb(active) {
      thumbs.querySelectorAll("[aria-current]").forEach((t) => t.removeAttribute("aria-current"));
      active?.setAttribute("aria-current", "true");
    }

    function renderThumbs() {
      const items = current.gallery.map((item, index) => {
        const button = element("button", { type: "button", className: `ring__thumb${item.type === "video" ? " ring__thumb--video" : ""}` });
        button.dataset.index = index;
        button.setAttribute("aria-label", item.type === "video" ? "Play the turning view" : item.alt);
        button.append(element("img", { src: item.thumb, alt: "", loading: "lazy" }));
        const li = element("li");
        li.append(button);
        return li;
      });
      if (slug) {
        const button = element("button", { type: "button", className: "ring__thumb ring__thumb--3d" });
        button.dataset["3d"] = "";
        button.setAttribute("aria-label", "Turn the ring in 3D");
        button.append(element("span", { textContent: "3D" }));
        const li = element("li");
        li.append(button);
        items.push(li);
      }
      thumbs.replaceChildren(...items);
    }

    function choose(variant) {
      current = variant;
      variant.options.forEach((value, i) => {
        const set = fieldsets[i];
        if (!set) return;
        set.querySelector("[data-option-label]").textContent = value;
        set.querySelectorAll("[data-value]").forEach((swatch) => {
          if (swatch.dataset.value === value) swatch.setAttribute("aria-current", "true");
          else swatch.removeAttribute("aria-current");
          swatch.href = (closest(variant.options, i, swatch.dataset.value) || variant).url;
        });
      });
      if (price) price.textContent = variant.price;
      history.replaceState(null, "", `${location.pathname}?variant=${variant.id}`);
      if (summary) {
        const note = summary.dataset.note ? ` (${summary.dataset.note})` : "";
        summary.value = `${summary.dataset.title} · ${variant.options.join(" · ")} · ${variant.price}${note} · ${location.origin}${variant.url}`;
      }
      if (announce) announce.textContent = `Showing ${variant.options.join(", ")}, ${variant.price}`;
      renderThumbs();
      if (showing === "3d" && iframe) {
        // iJewel applies a changed #? fragment without reloading.
        iframe.src = iframeSrc();
        markThumb(thumbs.querySelector("[data-3d]"));
      } else {
        show(typeof showing === "number" && showing < variant.gallery.length ? showing : 0);
      }
    }

    section.addEventListener("click", (event) => {
      const swatch = event.target.closest("[data-option] [data-value]");
      if (swatch) {
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        const next = closest(current.options, fieldsets.indexOf(swatch.closest("[data-option]")), swatch.dataset.value);
        if (next) choose(next);
        return;
      }
      const thumb = event.target.closest("[data-ring-thumbs] button");
      if (!thumb) return;
      if (thumb.hasAttribute("data-3d")) show3d();
      else show(Number(thumb.dataset.index));
    });

    section.dataset.ready = "true";
  }

  document.querySelectorAll("[data-ring-configurable]").forEach(start);
})();
